<template>
    <div class="container h-100">

        <div class="row justify-content-center align-items-center  h-80">
            <div class="col-12 text-center mt-0">
                <img src="@/assets/img/seohanGlobal2.png" alt="Seohan Logo" class="logo" width="500" height=auto>
            </div>
            <!-- <div class="col-12 text-center b2b-text welcome-text">
                <span >Seohan</span>
            </div>
            <div class="col-12 text-center b2b-text2 mb-30 welcome-text">
                Global Portal System
            </div> -->
            <div class="col-12 col-md-7 col-lg-6 col-xl-5 mt-16">
                <div class="card shadow">
                    <div
                    class="card-body"
                    style="padding: 15px 48px 20px 48px; height: 450px; ">
                        <span class="d-block text-center text-dark">You can log in with a partner company account.</span>

                        <!-- <h3 class="card-title text-center mb-3">Login</h3> -->
                        <form @submit.prevent="login">
                            <!-- Username input -->
                            <div class="form-outline form-custom mb-4" style="margin-top: 7vh;">
                                <input type="text" id="username" class="custom-input " v-model="username"
                                     required />
                                <label>Username</label>
                                <span class="login-span-custom"></span>
                            </div>

                            <!-- Password input -->
                            <div class="form-outline form-custom mb-7">
                                <input type="password" id="password" class="custom-input" v-model="password"
                                     required />
                                <label>Password</label>
                                <span class="login-span-custom"></span>
                            </div>

                            <!-- Submit button -->
                            <button type="submit" class="btn btn-info btn-login btn-lg btn-block">Login</button>
                        </form>

                        <div class="text-center mt-3">
                        <span class="text-primary forget-password-text"  >
                            If you forgot password Please ask Material Team
                        </span>
                        </div>

                        <!-- 모달 -->
                        <div v-if="showModal" class="modal-overlay">
                        <div class="modal-content">
                            <div class="modal-header" style="padding-top: 8px;">
                            <span class="modal-title">Reset Password</span>
                            <span class="modal-close" @click="showModal = false">&times;</span>
                            </div>
                            <div class="modal-body">
                            <div class="form-outline mb-7">
                                <input type="text" class="form-control" v-model="resetForm.username" placeholder="Username" />
                            </div>
                            <div class="form-outline mb-7">
                                <input type="password" class="form-control" v-model="resetForm.newPassword" placeholder="New Password" />
                            </div>
                            <div class="form-outline mb-10">
                                <input type="password" class="form-control" v-model="resetForm.confirmPassword" placeholder="Confirm New Password" />
                            </div>
                            <button class="btn btn-primary btn-block" @click="submitReset">Submit</button>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
// import axios from 'axios'

export default {
    data() {
        return {
            username: '',
            password: '',
            showModal: false,
            resetForm: {
                username: '',
                newPassword: '',
                confirmPassword: ''
            }
        };
    },
    beforeMount() {

    },
    methods: {
        async login() {
            try {
                const response = await fetch('/api/login', {
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        username: this.username.toUpperCase(), // ✅ 대문자로 변환
                        password: this.password
                    }),
                });

                const data = await response.json();
                if (data.success) {
                    // const sessionStatus = await axios.get('/api/session-status', { withCredentials: true });
                    // //console.log(sessionStatus);
                    if (data.accessToken) {
                        localStorage.setItem('accessToken', data.accessToken);
                        //console.log('[✔] accessToken 저장 완료');
                    }
                    this.$emit('updateUser', data.username);
                    this.$emit('updateUserName', data.userName);
                    sessionStorage.setItem("reloadAfterLogin", "true");

                    window.location.href = '/';
                    
                } else {
                    alert('Login failed!');
                }
            } catch (error) {
                console.error('Login error:', error);
                alert('Login failed!');
            }
            
        },

        async submitReset() {
            if (!this.resetForm.username || !this.resetForm.newPassword || !this.resetForm.confirmPassword) {
                alert("Enter all section.");
                return;
            }
            if (this.resetForm.newPassword !== this.resetForm.confirmPassword) {
                alert("Password does not match.");
                return;
            }

            try {
                const response = await fetch('/api/resetPassword', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        username: this.resetForm.username,
                        newPassword: this.resetForm.newPassword
                    })
                });

                const data = await response.json();
                if (data.success) {
                    alert("Password has been successfully reset.");
                    this.showModal = false;
                    // 입력값 초기화
                    this.resetForm.username = '';
                    this.resetForm.newPassword = '';
                    this.resetForm.confirmPassword = '';
                } else {
                    alert(data.message || "Username does not exist.");
                }
            } catch (err) {
                console.error('Reset Password Error:', err);
                alert("An error occurred while resetting the password.");
            }
        },


    }
};
</script>
  
<style>

.b2b-text {
    font-size: 80px; /* 글자 크기 */
    font-weight: bold; /* 글자 굵기 */
    color: #ffffff; /* 글자 색상 */
    letter-spacing: 15px; /* 글자 간격 */
    height: 16vh;
}
.font-size2 {
    font-size: 150px; /* 글자 크기 */
    font-weight: bold; /* 글자 굵기 */
    color: #ffffff; /* 글자 색상 */
    letter-spacing: 25px; /* 글자 간격 */
    height: 16vh;
}

.b2b-text2 {
    font-size: 30px; /* 글자 크기 */
    font-weight: bold; /* 글자 굵기 */
    color: #ffffff; /* 글자 색상 */
    text-transform: uppercase; /* 대문자로 변환 */
    letter-spacing: 2px; /* 글자 간격 */
}
/* Additional styles for better appearance */
/* 입력 상자 스타일링 */
.form-custom {
    position: relative;
    width: 300px;
    margin-left: 35px;
    margin-top: 50px;
}

.custom-input {
    font-size: 15px;
    color: #222222;
    width: 350px;
    border: none;
    border-bottom: solid #aaaaaa 1px;
    padding-bottom: 10px;
    padding-left: 10px;
    position: relative;
    background: none;
    z-index: 5;
}

.custom-input::placeholder {
    color: #aaaaaa;
}

.custom-input:focus {
    outline: none;
}

.login-span-custom {
    display: block;
    position: absolute;
    bottom: 0;
    left: 0%;
    /* right로만 바꿔주면 오 - 왼 */
    background-color: #666;
    width: 0;
    height: 2px;
    border-radius: 2px;
    transition: 0.5s;
}

label {
    position: absolute;
    color: #aaa;
    left: 10px;
    font-size: 20px;
    bottom: 8px;
    transition: all .2s;
}

.custom-input:focus~label,
.custom-input:valid~label {
    font-size: 16px;
    bottom: 40px;
    color: #666;
    font-weight: bold;
}

.custom-input:focus~span,
.custom-input:valid~span {
    width: 100%;
}

.logo {
    max-width: 100%;
    /* 이미지 너비 최대치 */
    height: auto;
    /* 이미지 높이 자동 조절 */
    /* 로고 아래 여백 */
}

.btn-login {
    background-color: #0B4DA2 !important
}

.btn-login:hover {
    border-color: #0B4DA2 !important
}

.form-control-lg {
    border-radius: 0.75rem;
    /* 둥근 모서리 */
    font-size: 1.25rem;
    /* 글꼴 크기 */
    padding: 0.75rem 1rem;
    /* 패딩 */
}

/* 로그인 버튼 스타일링 */
.btn-lg {
    padding: 0.75rem 1.25rem;
    /* 패딩 */
    border-radius: 0.75rem;
    /* 둥근 모서리 */
}

.container {
    height: calc(100vh - 56px);
    /* Adjust height to fill screen minus navbar height */
}

.login-page {
    background: url('../assets/img/rnd1.jpg') no-repeat center center fixed;
    background-size: cover;
    min-height: 100vh;
    width: 100%;
}

.login-background {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: -1;
}

.card {
  background: rgba(255, 255, 255, 0.85) !important;
  border-radius: 1rem;
  transition: transform 0.3s ease;
}



.form-control {
    border-radius: 0.5rem;
    /* Rounded form inputs */
}

.btn-block {
    border-radius: 0.5rem;
    /* Rounded button */
}
@media (max-width:1040px){
    .custom-input {
        width:250px;
    }
    .form-custom {
        margin-left:20px;
    }
}
@media (max-width: 760px) {
    .custom-input {
        width: 350px;
    }
}
@media (max-width: 400px) {
    .custom-input {
        width: 220px;
    }
}

label {
  color: #ffffff; /* 흰색 */
  font-weight: bold;
}
.btn-login {
  background-color: #0B4DA2 !important;
  color: #ffffff !important;
  font-weight: bold;
  font-size: 18px;
  letter-spacing: 1px;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.4); /* 대비 높이기 */
}

@font-face {
    font-family: 'hyundai';
    src: url('../assets/fonts/hundai-M.ttf') format('truetype');
    font-weight: bold;
    font-style: normal;
}
@font-face {
    font-family: 'hyundai';
    src: url('../assets/fonts/hyundai-L.ttf') format('truetype');
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSans';
    src: url('../assets/fonts/HYUNDAISANSHEADKRREGULAR.TTF') format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSans';
    src: url('../assets/fonts/HYUNDAISANSHEADKRBOLD.TTF') format('truetype');
    font-weight: bold;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSans';
    src: url('../assets/fonts/HYUNDAISANSHEADKRMEDIUM.TTF') format('truetype');
    font-weight: 500;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSans';
    src: url('../assets/fonts/HYUNDAISANSHEADKRLIGHT.TTF') format('truetype');
    font-weight: 300;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSansText';
    src: url('../assets/fonts/HYUNDAISANSTEXTKRREGULAR.TTF') format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSansText';
    src: url('../assets/fonts/HYUNDAISANSTEXTKRMEDIUM.TTF') format('truetype');
    font-weight: 500;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSansText';
    src: url('../assets/fonts/HYUNDAISANSTEXTKRBOLD.TTF') format('truetype');
    font-weight: bold;
    font-style: normal;
}
@font-face {
    font-family: 'Gothic';
    src: url('../assets/fonts/GothicA1-Bold.ttf') format('truetype');
    font-weight: bold;
    font-style: normal;
}
@font-face {
    font-family: 'Orbitron';
    src: url('../assets/fonts/TitilliumWeb-Bold.ttf') format('truetype');
    font-style: normal;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-content {
  background: white;
  padding: 30px;
  border-radius: 12px;
  width: 400px; /* 적당한 기본 너비 */
  max-width: 30vw; /* 작은 화면에서도 너무 안 커지도록 */
  position: relative;
  box-shadow: 0 5px 20px rgba(0,0,0,0.2);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-top: 8px;
}

.modal-title {
  font-size: 20px;
  font-weight: bold;
}

.modal-close {
  cursor: pointer;
  font-size: 24px;
  font-weight: bold;
  color: #666;
}

.modal-close:hover {
  color: #000;
}

.forget-password-text {
  font-size: 15px;
  text-decoration: underline;
}
.modal-body input.form-control {
  border: none;
  border-bottom: 1px solid #aaa;
  border-radius: 0;
  box-shadow: none;
  padding-left: 0;
  font-size: 15px;
  transition: border-color 0.3s;
}

.modal-body input.form-control:focus {
  outline: none;
  border-bottom: 2px solid #0B4DA2;
}

.modal-body .btn-primary {
  background-color: #0B4DA2;
  color: #fff;
  font-weight: bold;
  border: none;
  border-radius: 6px;
  padding: 10px 16px;
  font-size: 16px;
  width: 100%;
  transition: background-color 0.3s ease;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15); /* ✅ 회색 그림자 */

}

.modal-body .btn-primary:hover {
  background-color: #083b7a;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15); /* ✅ 회색 그림자 */

}


</style>
